<template>
  <v-simple-table class="table">
    <thead>
      <tr>
        <th class="text-left">
          {{ localStorage.translations.pages.statistic_employee.tables['lichnaya-otvetstvennost'] }}
        </th>
        <th class="text-left">
          {{ localStorage.translations.pages.statistic_employee.tables['dopolnitelnaya-rabota'] }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <div class="work_time">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 20C16.4 20 20 16.4 20 12C20 7.6 16.4 4 12 4C7.6 4 4 7.6 4 12C4 16.4 7.6 20 12 20ZM12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2ZM17 11.5V13H11V7H12.5V11.5H17Z"
                fill="#EEEEEE"
              />
            </svg>
            <div class="work_time-text f14">
              {{ time_work }}
            </div>
          </div>
        </td>
        <td>{{ time_extra }}</td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  name: 'TimeControlShowEmployeeTableAllTime',
  props: ['time_work', 'time_extra'],
}
</script>

<style lang="scss" scoped>
.table:deep() {
  width: 100%;
  box-shadow: 0px 6px 18px rgba(92, 81, 81, 0.06);
  :deep() .v-data-table__wrapper {
    overflow: visible;
  }
  height: max-content;
  thead {
    tr {
      background-color: #277faf;
      th {
        font-weight: 500;
        color: #ffffff !important;
        border-bottom: none !important;
      }
    }
  }

  tr {
    th,
    td {
      &:first-child {
        padding-left: 30px;
        @media #{map-get($display-breakpoints, 'xs-only')} {
          padding-left: 20px;
          padding-right: 20px;
        }
      }
      // &:last-child {
      //     padding-right: 30px;
      //     @media #{map-get($display-breakpoints, 'xs-only')} {
      //         padding-left: 5px;
      //         padding-right: 10px;
      //     }
      // }
      &:nth-of-type(1) {
        width: max-content;
        @media #{map-get($display-breakpoints, 'xs-only')} {
          width: auto;
        }
      }
      // &:nth-of-type(2) {
      //     width: 280px;
      //     @media #{map-get($display-breakpoints, 'xs-only')} {
      //         width: auto;
      //     }
      // }
    }
    td {
      height: 64px !important;
    }
  }
  .noData {
    padding: 30px;
  }
  .work_time {
    background: #277faf;
    width: max-content;
    padding: 6px 9px;
    display: flex;
    column-gap: 10px;
    align-items: center;
    align-content: center;
    border-radius: 4px;
    &-text {
      color: #ffffff;
    }
  }
}
</style>
